/* Google Analytics 4 via gtag.js. Loads only in production builds that define REACT_APP_GA_ID,
 * and never inside the prerender browser. Page views are sent on every route change. */
// The site's existing GA4 property; override with REACT_APP_GA_ID at build time.
const GA_ID = process.env.REACT_APP_GA_ID || "G-KCHCQ02N3V";

function enabled() {
  return !!GA_ID && process.env.NODE_ENV === "production" && typeof window !== "undefined" && !window.navigator.webdriver;
}

export function initAnalytics() {
  if (!enabled() || window.__paGaLoaded) return;
  window.__paGaLoaded = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false, anonymize_ip: true });
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_ID)}`;
  document.head.appendChild(s);
}

export function trackPageView(path, title) {
  if (!enabled() || !window.gtag) return;
  window.gtag("event", "page_view", { page_path: path, page_title: title || document.title, page_location: window.location.href });
}

export function trackEvent(name, params = {}) {
  if (!enabled() || !window.gtag) return;
  window.gtag("event", name, params);
}
